// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ele from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import qs from 'qs'
import "../static/iconfont.css"
import global from '@/api/global'
import api from './api'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import VueAMap from 'vue-amap'
import md5 from 'js-md5'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import animated from 'animate.css' // npm install animate.css --save安装，在引入
import rem from '@/api/rem.js'
// import hf from '@/api/hf'
// import 'animate.css'
import 'swiper/swiper-bundle.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'


Vue.config.productionTip = false

Vue.prototype.$store = store;
Vue.prototype.$qs = qs;
Vue.prototype.md5 = md5;
Vue.prototype.$video = Video;
Vue.prototype.global = global;
Vue.prototype.ele = ele;
Vue.prototype.animated = animated;
// Vue.prototype.hf = hf;
Vue.prototype.rem = rem;

Vue.use(ele, { size: 'small', zIndex: 3000 });
Vue.use(api);
// Vue.use(hf);
Vue.use(VueAwesomeSwiper)
Vue.component('chart', ECharts)

 // npm install animate.css --save安装，在引入




Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1365ae7e384d897216289d2e93d271d7',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
})

router.beforeEach((to, from, next) => {
  if (to.path) {
    router.app.$store.commit('syncLoginState');
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js